<template>
  <div>
    <b-row>
      <b-col>
        <span style="font-size: 1.2em; font-weight: 700; color: #233c7c;">
          Price Details
        </span>
      </b-col>
    </b-row>

    <hr style="border-top: 2px solid #dddddd;">

    <b-row v-for="(item, i) in items" :key="i">
      <b-col>
        {{ item.name }}
      </b-col>
      <b-col class="text-right">
        {{ item.qty }} x {{ item.currencyIDR }} {{ toMoney(item.priceIDR) }}
      </b-col>
    </b-row>

    <b-row class="mt-4 py-2" style="background-color: #dddddd; font-size: 18px; font-weight: 500; border-radius: 5px;">
      <b-col>
        Total
      </b-col>
      <b-col class="text-right">
        {{ final_currency }} {{ toMoney(final_price) }}
      </b-col>
    </b-row>

    <b-row class="mt-4">
      <b-col style="color: #aaaaaa; font-style: italic;">
        An extra fee of Rp. 311.218/hr will be charged for every extra hours.
        <br>
        (price may change at any order)
        <br>
        Meal for tour guide is borne by Customer.
      </b-col>
    </b-row>
  </div>
</template>

<script>
// external dependencies

// custom component

// api call

export default {
  name: 'Order_PriceDetail',
  props: ['items', 'final_currency', 'final_price'],
  components: {
  },
  data () {
    return {
    }
  },
  methods: {
    // PREREQUISITES
    toMoney: function (int) {
      if (int) return int.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.')
    }
    // END PREREQUISITES

    // HTTP REQUEST
    // END HTTP REQUEST
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Order/PriceDetail/PriceDetail.vue